import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useFocusOnMount from 'hooks/useFocusOnMount';
import Button from 'components/Button';
import Stack from 'components/Stack';
import Text from 'components/Text';
import InlineList from 'components/InlineList';
import { CommentSizesContext } from '../Context';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DeleteConfirmation(_ref) {
  var id = _ref.id,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var buttonRef = useFocusOnMount();
  var size = useContext(CommentSizesContext);
  var isDefaultSize = size === 'DEFAULT';
  var buttonSize = isDefaultSize ? 'small' : 'medium';
  var titleId = "delete-comment-".concat(id);
  return /*#__PURE__*/_jsx("div", {
    role: "dialog",
    "aria-labelledby": titleId,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xxs",
      pl: "xs",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        id: titleId,
        size: isDefaultSize ? 'xs' : ['xs', 'm'],
        breakpoints: "m",
        children: t('delete_comment_are_you_sure')
      }), /*#__PURE__*/_jsxs(InlineList, {
        as: "span",
        itemAs: "span",
        spacing: "xs",
        children: [/*#__PURE__*/_jsx(Button, {
          ref: buttonRef,
          size: buttonSize,
          onClick: onCancel,
          children: t('actions_keep')
        }), /*#__PURE__*/_jsx(Button, {
          variant: "important",
          size: buttonSize,
          onClick: onConfirm,
          children: t('actions_delete')
        })]
      })]
    })
  });
}
export default DeleteConfirmation;